import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-0"}],["path",{"d":"M10 8l2 5l2 -5","key":"svg-1"}],["path",{"d":"M12 16v-3","key":"svg-2"}]]

const IconSquareLetterY = createReactComponent('outline', 'square-letter-y', 'SquareLetterY', __iconNode);

export default IconSquareLetterY;